import * as GridLayout from '@/components/GridLayout/GridLayout'
import { ProductPurchase } from '@/components/ProductPurchase/ProductPurchase'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'

type ProductPurchaseBlockProps = SbBaseBlockProps<{
  products: Array<string>
  productByline?: string
  preSelectFirstProduct?: boolean
  campaignCode?: string
  ribbonText?: string
  promoteInboundSales?: boolean
}>

export const ProductPurchaseBlock = ({ blok, nested }: ProductPurchaseBlockProps) => {
  return (
    <GridLayout.Root {...storyblokEditable(blok)} nested={nested}>
      <GridLayout.Content width="1" align="center">
        <ProductPurchase
          products={blok.products}
          productByline={blok.productByline}
          preSelectFirstProduct={blok.preSelectFirstProduct}
          ribbonText={blok.ribbonText}
          nested={nested}
          campaignCode={blok.campaignCode}
          promoteInboundSales={blok.promoteInboundSales}
          showHeader={true}
        />
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
